module.exports = __webpack_public_path__ + "images/four-year-club-13b8bc456d3e06f98ddfb065545c054a.png";